import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";

export const container = (theme: ExactTheme) => css`
  position: fixed;
  pointer-events: none;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;
